export default __webpack_public_path__ + "static/media/blue_bubble_bg.c1b45d58.png";